<template>
  <nav-bar :createAction="true" @create="createReport" />
  
  <main-container>
    <ModalPatientValidSignature/>
    <list-group class="list-group" v-if="reportStore.reports.length > 0">
      <list-item class="list-group-item list-group-item-action" v-for="obj in reportStore.reports" :key="obj.id" v-on:click="updateReport(obj.id)">   

        <template v-slot:title>                 
          <h5 class="mb-1 fw-bold">{{ obj.title }}</h5>                            
        </template>
        
        <template v-slot:info>
          <HumorEmojis :humor="obj.humor" />                
        </template>       

        <template v-slot:complement>
          <div class="d-flex w-100 justify-content-between align-items-center">
            <div class="d-flex w-100">
              <p class="mb-1">{{ formatShortDate(obj.date) }}</p> 
              <p class="mb-1 px-1">{{ `(${convertPeriod(obj.period)})` }}</p> 
            </div>
            <div class="d-flex">
              <div class="px-2" @click="deleteReport(obj.id, obj.title, $event)">
                <font-awesome-icon icon="trash" class="red" />
              </div>
              <div class="d-flex align-items-center" v-if="obj.pending">                
                <font-awesome-icon icon="check-double" class="yellow" />              
                <p class="p-0 m-0"><small>Pendente</small></p>              
              </div>
              <div class="d-flex align-items-center" v-else>
                <font-awesome-icon icon="check-double" class="green" />
                <p class="p-0 m-0"><small>Enviado</small></p>              
              </div>                                          
            </div>
          </div>
                      
        </template>                                        
      </list-item>         
    </list-group>

    <list-group class="list-group" v-else>
      <list-item>   
        <template v-slot:title>            
          <h5 class="mb-1 fw">Nenhum Relato Encontrado!</h5>                        
        </template>                           
      </list-item>         
    </list-group>

  
  </main-container> 

  <bottom-bar />

</template>

<script>
import HumorEmojis from "../../components/Humor/HumorEmojis.vue";
import { useReportStore } from '@/store/report';
import { useUserStore } from '@/store/user';
import { formatShortDate, convertPeriod } from '@/services/formatters';
import { confirmOperation } from '@/services/popups';
import ModalPatientValidSignature from "../../components/Modal/ModalPatientValidSignature.vue";

export default {
    name:"ReportsListView", 
    inject:["mySpinner"],    
    components: {
      HumorEmojis,
      ModalPatientValidSignature
    },
    setup() {
      const reportStore = useReportStore();
      const userStore = useUserStore();

      return { reportStore, userStore }
    },    
    async mounted() {           
      this.mySpinner.loading = true;                     
      await this.reportStore.getReports(this.userStore.getUser.id);
      this.mySpinner.loading = false;
      this.reportStore.postUnsentReports();
    },     
    methods: {
      createReport() {        
        this.$router.push('/reports/create');        
      },
      updateReport(id) {      
        this.$router.push(`/reports/${id}`);
      },
      async deleteReport(id, title, event) {
        event.stopPropagation();
        const result = await confirmOperation("Confirmação", `Deseja deletar o relato "${title}" ?`);
        if (result) {
          await this.reportStore.deleteReport(id);
        }        
      },
      formatShortDate,
      convertPeriod   
    }
}

</script>

<style lang="css" scoped>
    @import'../../assets/css/_colors';
    @import'../../assets/css/_reports';
</style>
